import * as React                                    from 'react';
import { connect }                                   from 'react-redux';
import { useHistory }                                from 'react-router-dom';
import type { Action, Dispatch }                     from 'redux';
import { formValueSelector, reset, SubmissionError } from 'redux-form';
import type { InjectedFormProps }                    from 'redux-form';
import DV                                            from 'ts-data-validator';

import Preloader     from '../../../../components/containers/preloader';
import { useCommon } from '../../../../providers/common';
import { useModal }  from '../../../../providers/modal';
import { useUser }   from '../../../../providers/user';

import type { CompletedProjectOrderProps } from './completed-project.order.props';
import { CompletedProjectForm }            from './components';
import './completed-project.order.style.scss';

const CompletedProjectOrder: React.FC<CompletedProjectOrderProps> = function(props) {
  const history = useHistory();

  const {
          dispatch,
          id,
          userName,
          userPhone,
        } = props;

  const common: any = useCommon();
  const modal: any  = useModal();
  const user: any   = useUser();

  const [shouldPreload, setShouldPreload] = React.useState(false);

  const completedProjectPage = React.useMemo(() => {
    const page = common.pages.find((page: any) => page.template === 'completed-project');

    if (!page) {
      return '';
    }

    return `/${page.urlKey}`;
  }, [common.pages]);

  const onSubmit = React.useCallback((event: React.SubmitEvent<HTMLFormElement>, handleSubmit: InjectedFormProps['handleSubmit'], valid: boolean) => {
    event.preventDefault();

    if (valid) {
      setShouldPreload(true);
    }

    const _token = user.tokenList.PHONE || null;
    const path   = `${window.location.origin}${completedProjectPage}?id=${id}`;

    handleSubmit((values: any) => {
      const validateValues = {
        ...values,
        _token,
        description: `Заявка на консультацию по реализованному проекту ${path}`,
      };

      return user.send(validateValues)
        .then(() => {
          dispatch(reset('CompletedProjectForm'));
          setShouldPreload(false);
          modal.hideModal();

          if (completedProjectPage) {
            history.replace(completedProjectPage);
          }
        })
        .catch((errors: any) => {
          setShouldPreload(false);
          throw new SubmissionError(errors);
        });
    })(event);
  }, [completedProjectPage, dispatch, user.tokenList]);

  const formProps = React.useMemo(() => {
    const name = userName ?? (DV.isString(user.name.first_name) && DV.isString(user.name.last_name)
      ? `${user.name.last_name} ${user.name.first_name}${DV.isString(user.name.patronymic)
        ? ` ${user.name.patronymic}`
        : ''}`
      : null);

    const props: any = { submitForm: onSubmit };

    if (user.userInitialStateLoaded && user.appealInitialStateLoaded) {
      const appealTypeId = user.appealTypes.find((item: any) => item.aliasKey === 'PHONE')?.appealTypeId;
      const _token       = user.tokenList.PHONE || null;

      props.initialValues = {
        appealTypeId,
        aliasKey: 'PHONE',
        name,
        phone:    userPhone || user.phone,
        _token,
      };
    }

    return props;
  }, [onSubmit, user, userName, userPhone]);

  React.useEffect(() => {
    if (!Object.hasOwn(user.tokenList, 'PHONE')) {
      user.getToken('PHONE');
    }
  }, [user.tokenList]);

  if (!user.appealInitialStateLoaded || shouldPreload) {
    return <Preloader />;
  }

  return (
    <>
      <CompletedProjectForm
        {...formProps}
      />
    </>
  );
};

function mapStateToProps(state: any) {
  const form = formValueSelector('CompletedProjectForm');

  return {
    userName:  form(state, 'name') || null,
    userPhone: form(state, 'phone') || null,
  };
}

function mapDispatchToProps(dispatch: Dispatch<Action>) {
  return {
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CompletedProjectOrder);